import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logOut } from 'modules/user';
import { browserHistory } from 'react-router';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getSupportedLocales, getLocaleDisplayName } from '../intl/helpers';

class Navigation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      citefixDismissed: typeof localStorage !== 'undefined' && localStorage.getItem('citefix_banner_dismissed') === 'true',
      currentPath: ''
    };
  }

  componentDidMount() {
    this.setState({ currentPath: window.location.pathname });
    this.unlisten = browserHistory.listen(location => this.setState({ currentPath: location.pathname }));
  }

  componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  }

  current(path) {
    const { intl } = this.props;
    return this.state.currentPath.indexOf('/' + intl.locale + path) === 0 ? 'page' : undefined;
  }

  dismissCitefix(e) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('citefix_banner_dismissed', 'true');
    }
    this.setState({ citefixDismissed: true });
  }

  render() {
    let { user, isPreview, intl, dispatch } = this.props;

    if (!user.authenticated || isPreview) return (<div></div>);
    return (
      <nav className="navbar-fixed-left">
        {!this.state.citefixDismissed &&
          <a
            className="citefix-banner"
            href="https://apps.shopify.com/citefix"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button
              type="button"
              className="citefix-dismiss"
              title={intl.formatMessage({ id: 'nav.dismiss', defaultMessage: 'Dismiss' })}
              onClick={this.dismissCitefix.bind(this)}
            >
              <i className="fa fa-times"></i>
            </button>
            <span className="citefix-badge"><i className="fa fa-bolt"></i> New app</span>
            <p className="citefix-title">CiteFix</p>
            <p className="citefix-desc"><FormattedMessage id="nav.citefixDesc" defaultMessage="See the answer AI gives buyers, the pages it cited, and approve every fix yourself." /></p>
            <span className="citefix-cta"><FormattedMessage id="nav.citefixCta" defaultMessage="Check it out" /> <i className="fa fa-arrow-right"></i></span>
          </a>
        }
        <div className="nav-section">
          <div className="nav-section-label"><FormattedMessage id="nav.main" /></div>
          <a title={intl.formatMessage({ id: 'nav.ordersAndInvoices' })} id="orders-menu" aria-current={this.current('/dashboard')} className="navbar-item" href={'/' + intl.locale + '/dashboard'}>
            <i className="fa fa-list navbar-item-icon"></i>
            <span className="navbar-item-text"><FormattedMessage id="nav.ordersAndInvoices" /></span>
          </a>
          <a title={intl.formatMessage({ id: 'nav.drafts' })} id="drafts-menu" className="navbar-item navbar-subitem" aria-current={this.current('/drafts')} href={'/' + intl.locale + '/drafts'}>
            <i className="fa fa-file-text-o navbar-item-icon"></i>
            <span className="navbar-item-text"><FormattedMessage id="nav.drafts" /></span>
          </a>
          <a title={intl.formatMessage({ id: 'nav.automation' })} id="autopilot-menu" aria-current={this.current('/autopilot')} className="navbar-item" href={'/' + intl.locale + '/autopilot'}>
            <i className="fa fa-magic navbar-item-icon"></i>
            <span className="navbar-item-text"><FormattedMessage id="nav.automation" /></span>
          </a>
        </div>

        {user && user.profile && user.profile.subscription !== "suspended" &&
          <div className="nav-section">
            <div className="nav-section-label"><FormattedMessage id="nav.workspace" /></div>
            <a title={intl.formatMessage({ id: 'nav.templates' })} id="templates-menu" aria-current={this.current('/templates')} className="navbar-item" href={'/' + intl.locale + '/templates'}>
              <i className="fa fa-paint-brush navbar-item-icon"></i>
              <span className="navbar-item-text"><FormattedMessage id="nav.templates" /></span>
            </a>
            <a title={intl.formatMessage({ id: 'nav.delivery' })} id="delivery-menu" aria-current={this.current('/delivery')} className="navbar-item" href={'/' + intl.locale + '/delivery'}>
              <i className="fa fa-paper-plane navbar-item-icon"></i>
              <span className="navbar-item-text"><FormattedMessage id="nav.delivery" /></span>
            </a>
            <a title={intl.formatMessage({ id: 'nav.settings' })} id="settings-menu" aria-current={this.current('/bookkeeping')} className="navbar-item" href={'/' + intl.locale + '/bookkeeping'}>
              <i className="fa fa-cog navbar-item-icon"></i>
              <span className="navbar-item-text"><FormattedMessage id="nav.settings" /></span>
            </a>
            <a title={intl.formatMessage({ id: 'nav.shippingLabels' })} id="labels" aria-current={this.current('/labels')} className="navbar-item" href={'/' + intl.locale + '/labels'}>
              <i className="fa fa-tag navbar-item-icon"></i>
              <span className="navbar-item-text"><FormattedMessage id="nav.shippingLabels" /></span>
            </a>
            <a title={intl.formatMessage({ id: 'nav.subscriptions' })} id="billing-menu" aria-current={this.current('/billing')} className="navbar-item" href={'/' + intl.locale + '/billing'}>
              <i className="fa fa-credit-card navbar-item-icon"></i>
              <span className="navbar-item-text"><FormattedMessage id="nav.subscriptions" /></span>
            </a>
          </div>
        }

        <div className="nav-section">
          <div className="nav-section-label"><FormattedMessage id="nav.support" /></div>
          <a id="dev-menu" aria-current={this.current('/developer')} title={intl.formatMessage({ id: 'nav.developer' })} className="navbar-item" href={'/' + intl.locale + '/developer'}>
            <i className="fa fa-code navbar-item-icon"></i>
            <span className="navbar-item-text"><FormattedMessage id="nav.developer" /></span>
          </a>
          <a id="review-menu" title={intl.formatMessage({ id: 'nav.writeReview' })} href="https://apps.shopify.com/invoice-browse?#modal-show=ReviewListingModal" className="navbar-item" target="_blank" rel="noopener noreferrer">
            <i className="fa fa-star navbar-item-icon"></i>
            <span className="navbar-item-text"><FormattedMessage id="nav.writeReview" /></span>
          </a>
          <a title={intl.formatMessage({ id: 'nav.supportTicket' })} href="mailto:contact@growth-connections.com" className="navbar-item">
            <i className="fa fa-life-ring navbar-item-icon"></i>
            <span className="navbar-item-text"><FormattedMessage id="nav.supportTicket" /></span>
          </a>
          <a id="welcome-tour-menu" className="navbar-item" onClick={() => {
            localStorage.setItem(user.shopify.shopName + 'joyride-index', 0);
            localStorage.setItem(user.shopify.shopName + 'run-joyride', null);
            location.href = '/' + intl.locale + '/dashboard';
          }} title={intl.formatMessage({ id: 'nav.welcomeTour' })}>
            <i className="fa fa-compass navbar-item-icon"></i>
            <span className="navbar-item-text"><FormattedMessage id="nav.welcomeTour" /></span>
          </a>
        </div>

        <div className="nav-section nav-section-bottom">
          <div className="navbar-item navbar-locale-item">
            <i className="fa fa-globe navbar-item-icon"></i>
            <select
              value={intl.locale}
              onChange={(e) => {
                const newLocale = e.target.value;
                if (typeof localStorage !== 'undefined') {
                  localStorage.setItem('invoicebrowse_locale', newLocale);
                }
                const path = window.location.pathname.replace(/^\/[a-z]{2}(-[A-Z]{2})?(\/|$)/, '/');
                window.location.href = '/' + newLocale + (path === '/' ? '/dashboard' : path);
              }}
              className="navbar-locale"
            >
              {getSupportedLocales().map(code => (
                <option key={code} value={code}>{getLocaleDisplayName(code)}</option>
              ))}
            </select>
          </div>
          <a title={intl.formatMessage({ id: 'nav.logout' })} className="navbar-item" onClick={() => { dispatch(logOut(intl.locale)) }}>
            <i className="fa fa-sign-out navbar-item-icon"></i>
            <span className="navbar-item-text"><FormattedMessage id="nav.logout" /></span>
          </a>
          {user.isAdmin && (
            <a title={intl.formatMessage({ id: 'nav.administratorConsole' })} className="navbar-item" aria-current={this.current('/administrator')} onClick={() => { browserHistory.push('/' + intl.locale + '/administrator') }}>
              <i className="fa fa-lock navbar-item-icon"></i>
              <span className="navbar-item-text"><FormattedMessage id="nav.administratorConsole" /></span>
            </a>
          )}
        </div>
      </nav>
    );
  }
}

Navigation.propTypes = {
  user: PropTypes.object,
  logOut: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    user: state.user,
    isPreview: browserHistory && browserHistory.getCurrentLocation().pathname.indexOf('/preview') !== -1,
    isEditor: browserHistory && browserHistory.getCurrentLocation().pathname.indexOf('/editor') !== -1,
    logOut: logOut
  };
}

export default injectIntl(connect(mapStateToProps)(Navigation));



// WEBPACK FOOTER //
// app/containers/Navigation.jsx